import { awsApiInstance } from '../api/aws-api';
import { apiRetry } from '../api/api-helper';

import { IPrintCards } from '../models/cards.interface';
import { handleRouteError } from './route-helpers/route-error';

/**
 * Gets a print files from an api request 
 * 
 * @param {string} batchId the batch id
 * @param {string} cardNumber the card number
 * 
 * @returns {object} the api response
 */
export const printCard = async (batchId?: string, cardNumber?: string): Promise<IPrintCards> => {
  try {
    apiRetry(awsApiInstance);

    const { data } = await awsApiInstance.get('/cards/print', {
      params: {
        batchId,
        cardNumber
      }
    });

    return data;
  } catch ( error ) {
    handleRouteError(error, 'Error printing card data');
    throw(error);
  }
}